import React, { useState } from "react";
import { Form, Input, Button, Card, Typography } from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import ApiLoadingSpinner from "../../../components/utils/ApiLoadingSpinner";

const AddVendor = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("admin"));
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    if (values.vendor_password !== values.vendor_password2) {
      form.setFields([
        {
          name: "vendor_password2",
          errors: [t("pass_err")],
        },
      ]);
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(
        `${process.env.REACT_APP_APIURL}/admin/createvendor`,
        {
          method: "POST",
          body: JSON.stringify(values),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      const response = await res.json();

      if (response?.status_code === 200) {
        toast.success(`${t("add_vendor_text")}`);
        navigate("/admin/vendors");
      } else {
        toast.error(response?.message || response?.err);
      }
    } catch (err) {
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <ApiLoadingSpinner />;

  return (
    <>
      <Typography.Title level={3}>{t("add_vendor_title")}</Typography.Title>

      <Card className="max-w-xl mx-auto shadow-sm">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            label={t("Vendor_Name")}
            name="vendor_name"
            rules={[{ required: true, message: t("This field is required") }]}
          >
            <Input placeholder={t("Vendor_Name")} />
          </Form.Item>

          <Form.Item
            label={t("form_email")}
            name="vendor_email"
            rules={[
              { required: true, message: t("This field is required") },
              { type: "email", message: t("Invalid email address") },
            ]}
          >
            <Input placeholder={t("form_email")} />
          </Form.Item>

          <Form.Item
            label={t("Phone Number")}
            name="vendor_contact"
            rules={[{ required: true, message: t("This field is required") }]}
          >
            <PhoneInput
              country={"sa"}
              inputStyle={{ width: "100%" }}
              placeholder={t("Phone Number")}
            />
          </Form.Item>

          <Form.Item
            label={t("l_p")}
            name="vendor_password"
            rules={[{ required: true, message: t("This field is required") }]}
          >
            <Input.Password placeholder={t("l_p_p")} />
          </Form.Item>

          <Form.Item
            label={t("l_c_p_p")}
            name="vendor_password2"
            dependencies={["vendor_password"]}
            rules={[
              { required: true, message: t("This field is required") },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("vendor_password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t("pass_err")));
                },
              }),
            ]}
          >
            <Input.Password placeholder={t("l_p_p")} />
          </Form.Item>

          <div className="flex justify-end gap-4">
            <Link to="/admin/vendors">
              <Button danger>{t("Cancel")}</Button>
            </Link>
            <button type="submit" className="btn btn-primary text-white btn-sm">
              {t("Save")}
            </button>
          </div>
        </Form>
      </Card>
    </>
  );
};

export default AddVendor;
